import * as React from 'react';
import { Identifier, TextFieldProps, useRecordContext, useTranslate } from 'react-admin';
import { Button } from '@mui/material';
import { Contract } from '../types';
import { Link } from 'react-router-dom';
import AddIcon from '@mui/icons-material/Add';

export type LinkToQbButtonProps = TextFieldProps & {
  type: string;
};

const LinkToQbButton = (props: LinkToQbButtonProps) => {
  const record = useRecordContext();
  const translate = useTranslate();

  let link = '';

  if(!record){ return null;}

  if(props.type == 'customerdetail' && record.accouting_reference_id == null) {return null;}

  if(props.type == 'invoice'){
    link = `https://app.qbo.intuit.com/app/invoice?txnId=${record.id}`
  }
  else if(props.type == 'payment'){
    link = `https://app.qbo.intuit.com/app/recvpayment?txnId=${record.id}`
  }
  else
  {
    link = `https://app.qbo.intuit.com/app/${props.type}?nameId=${record.accounting_reference_id}`
  }

  return record ? (
    <Button
    //   component={Link}
      target={'_blank'}
      href={link}
      // startIcon={<AddIcon />}
    >
      QB
    </Button>
  ) : null;
};

export default LinkToQbButton;
